import { getPCAComponents, getUSPlaceNames } from '../api'

const initialState = {
    isLoading: true,
    coordinates: [],
    locations:[]
}

export const knn = ({
    state: initialState,
    reducers: {
        setPCAComponents(state, knn) {
            return {
                ...state,
                coordinates: knn,
                isLoading: false
            }
        },
        setUSPlaceNames(state, places) {
            return {
                ...state,
                locations: places,
                isLoading: false
            }
        }
    },
    effects: {
        async loadPCAComponents(obj) {
            const knn = await getPCAComponents(obj)
            this.setPCAComponents(knn)
        },
        async loadUSPlaceNames() {
            const places = await getUSPlaceNames()
            this.setUSPlaceNames(places)
        }
    }
})
